import { Pipe, PipeTransform } from '@angular/core';
import { MimeCategory } from '@common/enums';

@Pipe({
  name: 'isFolder',
  pure: true
})
export class IsFolderPipe implements PipeTransform {
  transform(category: MimeCategory): boolean {
    return category === MimeCategory.Folder || category === MimeCategory.OneNoteFolder;
  }
}
